function save(filename, data) {
  const blob = new Blob([data], {type: 'application/gpx+xml'});
  if(window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  }
  else{
    const elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
}

const generateGpx = () => {
  window.gtag('event', "generateGpx")
  window.fbq('trackCustom', "generateGpx");

  var nextPortionIndex = 1
  var nextPortionStart = window.latestResult.portions[nextPortionIndex] && window.latestResult.portions[nextPortionIndex].start

  const latestPathPoint = window.latestResult.pathCoordinates[window.latestResult.pathCoordinates.length - 1]

  const data = `<?xml version="1.0" encoding="UTF-8" standalone="no" ?>
<gpx xmlns="http://www.topografix.com/GPX/1/1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd" version="1.1" creator="temps-de-marche-montagne.fr">
  <metadata>
    <name>trajet</name>
  </metadata>
  ${window.latestResult.portions.map(({start}) => {
    const coords = start.split(',')
    return `<wpt lat="${coords[1]}" lon="${coords[0]}"></wpt>\n`
  }).join('')}
  <wpt lat="${latestPathPoint[0]}" lon="${latestPathPoint[1]}"></wpt>
  <trk>
    <trkseg>
    ${
    window.latestResult.pathCoordinates.map((coords) => {
      var point = `<trkpt lat="${coords[0]}" lon="${coords[1]}"></trkpt>\n`
      
      if (nextPortionStart === `${coords[1]},${coords[0]}`) {
        point += "</trkseg></trk>\n<trk><trkseg>"
        nextPortionIndex += 1
        nextPortionStart = window.latestResult.portions[nextPortionIndex] && window.latestResult.portions[nextPortionIndex].start
      }
      return point
    }).join('')
    } 
    </trkseg>
  </trk>
</gpx>`
  save('trajet.gpx', data)
}

export default generateGpx